<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('common.action.delete') }}</div>
    <div slot="body">
      <template v-if="!params.isCreate">
        <dialog-selected-tips :count="params.data.length" :name="$t('bill.text_37')" :action="$t('common.action.delete')" />
        <dialog-table :data="params.data" :columns="params.columns.slice(0, 3)" />
      </template>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BillRateDeleteDialog',
  components: {
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
    }
  },
  created () {
    this.$r = new this.$Manager('rates', 'v1')
  },
  methods: {
    async doCreate (params) {
      return this.$r.performAction({
        id: this.params.rate_id,
        data: {
          rate_set_id: this.params.rate_set_id,
          enable_date: this.params.data[0].enable_date,
        },
        action: 'remove-rate',
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        this.loading = true
        await this.doCreate()
        this.loading = false
        this.params.success && this.params.success()
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
